export default __webpack_public_path__ + "static/media/rewards_hero.a10d5335.jpg";